<template>
  <router-view></router-view>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  name: 'Login',
  // data() {
  //   return {
  //     form: {
  //       username: '',
  //       password: ''
  //     }
  //   }
  // },
  // methods: {

  // },
  // created() {
  //   if (Cookies.get('token')) {
  //     this.$router.replace('/');
  //   }
  // }
}

</script>
<style></style>



// WEBPACK FOOTER //
// src/Auth/containers/Auth.vue